<template>
  <div class="">
    <div class="border-b border-gray-500 py-6 px-5">

      <div class="w-full">

        <ReplyOne></ReplyOne>
        <ReplyOne></ReplyOne>

        <div class="py-5 pl-10">
          <textarea class="shadow-md focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg bg-gray-100 h-16 w-full mb-2 appearance-none resize-none p-3"></textarea>
          <div class="flex justify-end items-center">
            <div class=" cursor-pointer rounded-full shadow-xl pr-6 py-2 text-center bg-gray-300 border-gray-500">
              <img src="../ics/avatar.svg" class="ml-3 mr-1 inline" alt="" />
              Reply as @wonglok831
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    ReplyOne: require('./ReplyOne.vue').default
  }
}
</script>

<style>

</style>
